export default __webpack_public_path__ + "static/media/small-mobile-info.c4680c3c.webp";